module.exports = __webpack_public_path__ + "img/9791130636405.351b33a4.jpg";